var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"range vertical-highest-first round",attrs:{"type":"range","min":_vm.min,"max":_vm.max,"step":_vm.step},domProps:{"value":_vm.value},on:{"input":_vm.emitInput,"change":_vm.emitChange}})}
var staticRenderFns = []

export { render, staticRenderFns }